/**
 * Retention event tracker - Session 18
 * Records session_start, action_viewed, action_accepted, action_dismissed
 * to Supabase retention_events table via /api/user?action=retention
 */

let sessionRecorded = false;

function getToken() {
  // Supabase stores session in localStorage
  try {
    const raw = localStorage.getItem("sb-mwyqmaoriekxnyzlklye-auth-token");
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed?.access_token || null;
    }
  } catch {}
  return null;
}

function sendRetentionEvent(eventType, eventData = {}) {
  const token = getToken();
  if (!token) return;
  fetch("/api/user?action=retention", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ event_type: eventType, event_data: eventData }),
  }).catch((err) => console.error('[retentionTracker:sendRetentionEvent] retention fetch failed:', err));
}

export function trackSessionStart() {
  if (sessionRecorded) return;
  sessionRecorded = true;
  sendRetentionEvent("session_start");
}

export function trackActionViewed(actionId, actionType) {
  sendRetentionEvent("action_viewed", { action_id: actionId, action_type: actionType });
}

export function trackActionAccepted(actionId, actionType) {
  sendRetentionEvent("action_accepted", { action_id: actionId, action_type: actionType });
}

export function trackActionDismissed(actionId, actionType) {
  sendRetentionEvent("action_dismissed", { action_id: actionId, action_type: actionType });
}

export function trackRetentionEvent(session, eventType, eventData = {}) {
  if (!session?.access_token) return;
  fetch("/api/user?action=retention", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ event_type: eventType, event_data: eventData }),
  }).catch((err) => console.error('[retentionTracker:trackRetentionEvent] retention fetch failed:', err));
}
